import axios from "axios";
import { Base_URL } from "../url";

export const fetchCompanyLocations = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CompanyLocationMaster`);
    //const response = await axios.get("https://192.168.29.243:7039/api/CompanyLocationMaster");
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching company locations!";
  }
};